
enum BulkProjectEditChangeReason {
  AdequacyTemplateCollectionId = "adequacyTemplateCollectionId",
  AdequacyTemplateCorrelationId = "adequacyTemplateCorrelationId",
  TimeDistanceCalculatorType = "timeDistanceCalculatorType",
  AccessCodeMapSetId = "accessCodeMapSetId",
  NetworkSpecialtyCodeMapSetId = "networkSpecialtyCodeMapSetId",
  MarketSpecialtyCodeMapSetId = "marketSpecialtyCodeMapSetId",
  ExcludedSpecialtyGroupCodes = "excludedSpecialtyGroupCodes",
  IncludedSpecialtyGroupCodes = "includedSpecialtyGroupCodes",
  ExcludedTelehealthSpecailtyGroupCodes = "excludedTelehealthSpecialtyGroupCodes",
  IncludedTelehealthSpecailtyGroupCodes = "includedTelehealthSpecialtyGroupCodes",
  MemberSetId = "memberSetId",
  MemberSetAlias = "memberSetAlias",
  MemberSetId2 = "memberSetId2",
  MemberSetAlias2 = "memberSetAlias2",
  NetworkProviderSetAlias = "networkProviderSetAlias",
  NetworkProviderSetId = "networkProviderSetId",
  ProspectProviderSetAlias = "prospectProviderSetAlias",
  ProspectProviderSetId = "prospectProviderSetId",
  MarketProviderSetAlias = "marketProviderSetAlias",
  MarketProviderSetId = "marketProviderSetId",
  NextClosestProviderSetAlias = "nextClosestProviderSetAlias",
  FileTypeId = "fileTypeId",
  FileTypeReason = "fileTypeReason",
  ProjectUtilizationCategoryId = "projectUtilizationCategoryId",
  LineOfBusinessId = "lineOfBusinessId",
  LineOfBusinessTypeId = "lineOfBusinessTypeId",
  Reason = "reason",
  StrictTimeAndDistance = "strictTimeAndDistance",
  AutoArchiveUnarchiveSpecialtyExceptions = "autoArchiveUnarchiveSpecialtyExceptions",
  ExcludeInVolumeActions = "excludeInVolumeActions",
  ShowCMSCredit = "showCMSCredit",
  IncludeGapAging = "includeGapAging",
  ShowAttestation = "showAttestation",
  ShowNppesDates = "showNppesDates",
  ShowAdvancedComparison = "showAdvancedComparison",
  ShowAverageDistance = "showAverageDistance",
  ShowMaximumDistance = "showMaximumDistance",
  ShowAverageTime = "showAverageTime",
  ShowMaximumTime = "showMaximumTime",
  HasZipSummaries = "hasZipSummaries",
  ShowNextClosestNetworkProviders = "showNextClosestNetworkProviders",
  ShowPatternOfCareProviders = "showPatternOfCareProviders",
  EnableRegulatoryExceptionReports = "enableRegulatoryExceptionReports",
  showCareJourneyScores = "showCareJourneyScores",
  ShowPgrConfidenceTier = "showPgrConfidenceTier",
  ShowClosestProviderReport = "showClosestProviderReport",
  ShowMipsScore = "showMipsScore",
  ShowPciData = "showPciData",
  ShowVaClaimsVolumeColumn = "showVaClaimsVolumeColumn",
  ShowTricareClaimsVolumeColumn = "showTricareClaimsVolumeColumn",
  ShowLocationConfidenceScores = "showLocationConfidenceScores",
  ShowMotiveAppropriatenessScore = "showMotiveAppropriatenessScore",
  ExcludeDeactivatedFacilitiesImpact = "excludeDeactivatedFacilitiesImpact",
  ExcludeDeactivatedFacilitiesNetwork = "excludeDeactivatedFacilitiesNetwork",
  ExcludeDeactivatedProvidersImpact = "excludeDeactivatedProvidersImpact",
  ExcludeDeactivatedProvidersNetwork = "excludeDeactivatedProvidersNetwork",
  ExcludeInvalidNppesNpiFacilitiesImpact = "excludeInvalidNppesNpiFacilitiesImpact",
  ExcludeInvalidNppesNpiFacilitiesNetwork = "excludeInvalidNppesNpiFacilitiesNetwork",
  ExcludeInvalidNppesNpiProvidersImpact = "excludeInvalidNppesNpiProvidersImpact",
  ExcludeInvalidNppesNpiProvidersNetwork = "excludeInvalidNppesNpiProvidersNetwork",
  ExcludeMissingNpiFacilitiesNetwork = "excludeMissingNpiFacilitiesNetwork",
  ExcludeMissingNpiFacilitiesImpact = "excludeMissingNpiFacilitiesImpact",
  ExcludeMissingNpiProvidersNetwork = "excludeMissingNpiProvidersNetwork",
  ExcludeMissingNpiProvidersImpact = "excludeMissingNpiProvidersImpact",
  ExcludeMedicareOptOutProvidersNetwork = "excludeMedicareOptOutProvidersNetwork",
  ExcludeOIGExcludedProvidersNetwork = "excludeOIGExcludedProvidersNetwork",
  ExcludePrecludedProvidersNetwork = "excludePrecludedProvidersNetwork",
  ExcludeMedicareOptOutProvidersImpact = "excludeMedicareOptOutProvidersImpact",
  ExcludeOIGExcludedProvidersImpact = "excludeOIGExcludedProvidersImpact",
  ExcludePrecludedProvidersImpact = "excludePrecludedProvidersImpact",
  IncludeInEnterpriseComplianceDashboard = "includeInEnterpriseComplianceDashboard",
  ExcludeProjectInSnowflakeDataShare = "excludeProjectInSnowflakeDataShare",
  RppoNonContractedProvidersIncludedInHsd = "rppoNonContractedProvidersIncludedInHsd",
  ShowPciDashboard = "showPciDashboard",
  UseMarketProvidersForMarketAnalysis = "useMarketProvidersForMarketAnalysis",
  UseNetworkProvidersForMarketAnalysis = "useNetworkProvidersForMarketAnalysis",
  UseProspectProvidersForMarketAnalysis = "useProspectProvidersForMarketAnalysis",
  ExcludeAccuracyPractitionerAtLocationInspector = "excludeAccuracyPractitionerAtLocationInspector",
  ExcludeProviderClaimsActivityInspector = "excludeProviderClaimsActivityInspector",
  ShowAffiliationsInsights = "showAffiliationsInsights",
  ShowNetworkIntegrityDashboard = "showNetworkIntegrityDashboard",
  ShowNetworkIntegrityCriticalAlerts = "showNetworkIntegrityCriticalAlerts",
  ShowNetworkIntegrityAttestationBasedAlerts = "showNetworkIntegrityAttestationBasedAlerts",
  AffiliationsDisplayOnNetworkAccordion = "affiliationsDisplayOnNetworkAccordion",
  RegulatorAssignmentClientId = "regulatorAssignmentClientId",
}

export {
  BulkProjectEditChangeReason
};
